module.exports = "/next-static/_next/static/images/hero_image_large-b89a97dce9c55c5857c131689cb43de6.png";